<template>
  <div class="content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-xl-6">
            <h2 class="card-title">Plan de Prévention Evolutif</h2>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8 col-md-offset-2 text-center">
              <h2 class="title text-danger">404 Non trouvée</h2>
              <h2 class="title">Oops! On dirait que cette page n'existe pas</h2>
              <a href="#"  @click="back" class="nav-link">Retour</a> 

              <router-link :to="{path:'/login'}">S'identifier</router-link> | 

              <router-link :to="{path:'/'}">Accueil</router-link> | 

      </div>
    </div>
  </div>
  </div>    
</template>


<script>
  export default {

    methods: {
      back() {this.$router.back()},
    }
  }

</script>
